module.exports = "<h1>Create new user</h1>\n\n<div [hidden]=\"!error\" class=\"alert alert-danger\" role=\"alert\">\n  <strong>Error:</strong> {{error}}\n</div>\n\n<div *ngIf=\"model && success\" class=\"alert alert-success\" role=\"alert\">\n  <strong>Success!</strong> The user has been sent an email to finish setting up thier new account.\n  <a [routerLink]=\"['/users/edit', model.id]\">Edit user</a> | <a routerLink=\"/users\">View All</a>\n</div>\n\n<user-form [loading]=\"loading\" (onSubmit)=\"createUser($event)\"></user-form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/create.user.component.html
// module id = 885
// module chunks = 1